export default function validation(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FACTURE_INTERVENANT_COMPTE_COMPTABLE_IS_REQUIRED') === 0) {
      const params = message.split('|')[0].split('@');
      const nomCommerciaux = params[1].replace('[', '').replace(']', '').split(',').join(', ');
      messages.push({
        message: 'validationFacture.compteComptableRequired',
        parametres: { nomCommerciaux: nomCommerciaux },
      });
    }
    if (message.indexOf('FACTURE_INTERVENANT_ADRESSE_ADRESSE_1_IS_REQUIRED') === 0) {
      const params = message.split('|')[0].split('@');
      const nomCommerciaux = params[1].replace('[', '').replace(']', '').split(',').join(', ');
      messages.push({
        message: 'validationFacture.adresseAdresse1Required',
        parametres: { nomCommerciaux: nomCommerciaux },
      });
    }
    if (message.indexOf('FACTURE_INTERVENANT_ADRESSE_CODE_POSTAL_IS_REQUIRED') === 0) {
      const params = message.split('|')[0].split('@');
      const nomCommerciaux = params[1].replace('[', '').replace(']', '').split(',').join(', ');
      messages.push({
        message: 'validationFacture.AdresseCodePostalRequired',
        parametres: { nomCommerciaux: nomCommerciaux },
      });
    }
    if (message.indexOf('FACTURE_INTERVENANT_SIRET_IS_REQUIRED') === 0) {
      const params = message.split('|')[0].split('@');
      const nomCommerciaux = params[1].replace('[', '').replace(']', '').split(',').join(', ');
      messages.push({
        message: 'validationFacture.siretRequired',
        parametres: { nomCommerciaux: nomCommerciaux },
      });
    }
    if (message.indexOf('FACTURE_INTERVENANT_TVA_INTRACOMMUNAUTAIRE_IS_REQUIRED') === 0) {
      const params = message.split('|')[0].split('@');
      const nomCommerciaux = params[1].replace('[', '').replace(']', '').split(',').join(', ');
      messages.push({
        message: 'validationFacture.tvaIntracommRequired',
        parametres: { nomCommerciaux: nomCommerciaux },
      });
    }
    if (message.indexOf('FACTURE_INTERVENANT_MODE_REGLEMENT_IS_REQUIRED') === 0) {
      const params = message.split('|')[0].split('@');
      const nomCommerciaux = params[1].replace('[', '').replace(']', '').split(',').join(', ');
      messages.push({
        message: 'validationFacture.modeReglementRequired',
        parametres: { nomCommerciaux: nomCommerciaux },
      });
    }
    if (message.indexOf('FACTURE_INTERVENANT_DELAI_REGLEMENT_IS_REQUIRED') === 0) {
      const params = message.split('|')[0].split('@');
      const nomCommerciaux = params[1].replace('[', '').replace(']', '').split(',').join(', ');
      messages.push({
        message: 'validationFacture.delaiReglementRequired',
        parametres: { nomCommerciaux: nomCommerciaux },
      });
    }
    if (message.indexOf('FACTURE_INTERVENANT_ADRESSE_PAYS_IS_REQUIRED') === 0) {
      const params = message.split('|')[0].split('@');
      const nomCommerciaux = params[1].replace('[', '').replace(']', '').split(',').join(', ');
      messages.push({
        message: 'validationFacture.adressePaysRequired',
        parametres: { nomCommerciaux: nomCommerciaux },
      });
    }
  });
}
